import useMedia from 'use-media'

import { mediaQueries } from '@redriverpress/system'

import VideoGenresDefaultSidebar from './VideoGenresDefaultSidebar'
import VideoGenresMdSidebar from './VideoGenresMdSidebar'

export default function Genres() {
  const isMd = useMedia(mediaQueries.md)

  return isMd ? <VideoGenresMdSidebar /> : <VideoGenresDefaultSidebar />
}
